export interface MiluimPeriod {
    from: string; //date string
    to: string; // date string
};

export enum RightType {
    AvneyPina = 1,
    NekudotZehut,
    DentalRight,
    Course,
    ExamDoesntCount,
    HighestGrade,
    TestTimeExtension,
    NoAttendanceRequired,
    IntermediateAssignmentsPtor,
    PtorMandatoryAttendance, // 24_25 
    AlternativeAssessment, // 24_25 "הערכה חלופית בקורס"
}

export interface CalculationResult {
    sum: number;
    type: RightType; //type of right
    reason: Record<Lang, string>;
    dentalRightTitle?: string;
    isGreater?: boolean; // if hakala is greater between Rector or Malag, it will be bold
    isMalag?: boolean;
    isFinalSum?: boolean; // 24_25 for final calc and present of ptorNZ and binCourse
    is24_25?: boolean;
};

export enum DegreeType {
    Musmach = "Musmach",
    Boger = "Boger",
    RefuaChishuvit = "Refua Chishuvit",

    // for business school:
    BschoolMusmach = "BschoolMusmach",
    BschoolMaslulMuatz = "BschoolMaslulMuatz",
    
    // for Dental Medicine faculty:
    DentalBogerShanaA = "DentalBogerShanaA",
    DentalBogerShanaB = "DentalBogerShanaB",
    DentalBogerShanaC = "DentalBogerShanaC",
    DentalDoctorShanaD = "DentalDoctorShanaD",
    DentalDoctorShanaE = "DentalDoctorShanaE",
    DentalDoctorShanaF = "DentalDoctorShanaF",
    DentalMusmach = "DentalMusmach"
}

export enum Lang {
    he = "he",
    en = "en"
}

export enum Faculty {
    CSE = "cse",
    General = "general",
    HUM = "hum",
    DENTAL = "dental", 
    BSCHOOL = "bschool" // business scholl
}
